import React, { useEffect, useRef, useState } from "react";
import { Marker } from "@react-google-maps/api";
import { animateMarkerMovement } from "../utility/UtilFunctions";

const ArcMarker = ({ marker, icon = () => {}, onClick = () => {} }) => {
  const markerRef = useRef(null);
  const [mstate, setMstate] = useState(marker);

  useEffect(() => {
    if (markerRef.current) {
      animateMarkerMovement(
        markerRef.current.marker,
        {
          lat: marker.CoordinateLatitude,
          lng: marker.CoordinateLongitude,
        },
        () => {
          setMstate(marker);
        }
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marker.CoordinateLatitude, marker.CoordinateLongitude, marker.Direction]);

  return (
    <Marker
      ref={markerRef}
      position={{
        lat: mstate.CoordinateLatitude,
        lng: mstate.CoordinateLongitude,
      }}
      icon={icon(
        mstate.Direction,
        mstate.TeamNumber,
        mstate.PinHsl_1,
        mstate.PinHsl_2
      )}
      onClick={onClick}
    />
  );
};

export default ArcMarker;
